import './properties.css'
import Property from '../property/Property'
import { prop } from '../property/data'
import Outlined from '../div/Outlined'

function Properties() {
    return (
        <div className='properties' id='price'>
        <h3 className='properties--title'>Our business rental rooms category</h3>
        <Outlined/>
        <div className='properties--wrapper'>
           {prop.map(p => (
            <Property prop={p}/>
           ))}
            </div>
        </div>
    )
}

export default Properties
